import InventoryCard from './InventoryCard';

export default InventoryCard;
